import { createBrowserRouter } from "react-router-dom";

import HomePage from "./pages/Home";
import LoginPage from "./pages/Login";
import RegPage from "./pages/Reg";
import TestPage from "./pages/tests/Test";
import TestPassPage from './pages/tests/TestPass'
import ControlPage from "./pages/Control";
import SettingPage from "./pages/admin/Setting";
import PharmaciesPage from "./pages/admin/Pharmacies";
import PharamcyPage from "./pages/admin/Pharmacy";
import PharamcyAddPage from "./pages/admin/PharmacyAdd";
import TestPemitPage from "./pages/admin/TestPemit";
import ResultsPage from "./pages/admin/Results";
import ResultPage from "./pages/admin/Result";
import RetakeResult from "./pages/admin/RetakeResult";
import RetakeTest from "./pages/admin/RetakeTest";
import UsersPage from "./pages/admin/Users";
import User from "./pages/admin/User";
import UserResultPage from "./pages/admin/UserResult";
import MasPage from "./pages/admin/Mas";
import MasUserPage from "./pages/admin/MasUser";
import MasAddPharmacy from "./pages/admin/MasAddPharmacy";
import AddMasPage from "./pages/admin/AddMas";
import TestsCategoryPage from "./pages/admin/TestsCategory";
import AddTestQuestionPage from "./pages/admin/AddTestQuestion";
import CheckTestsPage from "./pages/admin/CheckTests";
import EditTestPage from "./pages/admin/EditTest";
import AddTestCategoryPage from "./pages/admin/AddTestCategory";
import ReportsPage from "./pages/admin/Reports";
import ReportMasRegionPharmacyPage from "./pages/admin/ReportMasRegionPharmacy";
import ReportMasRegionPharmacyCategoryIdPage from "./pages/admin/ReportMasRegionPharmacyCategoryId";
import UserEditPage from "./pages/admin/UserEdit";



import RequireNotAuth from "./hoc/RequireNotAuth"; 
import RequireAuth from './hoc/RequireAuth'
import RequireAdmin from "./hoc/RequireAdmin";
import RequireSuperAdmin from "./hoc/RequireSuperAdmin";


import { Paths } from "./paths";
import { DefaultLayout } from "./layouts/DefaultLayout/DefaultLayout";


export const router = createBrowserRouter([
    
    {
      path: Paths.home,
      element: (
      <>
      <RequireNotAuth>
          <DefaultLayout>
            <HomePage />
          </DefaultLayout>
      </RequireNotAuth>
      </>
         
        
      ),
    },
    {
      path: Paths.login,
      element: (
        <>
          <RequireNotAuth>
            <DefaultLayout>
              <LoginPage />
            </DefaultLayout>
          </RequireNotAuth>
        </>
      ),
    
    },
    {
      path: Paths.reg,
      element: (
        <>
          <RequireNotAuth>
            <DefaultLayout>
              <RegPage />
            </DefaultLayout>
          </RequireNotAuth>
        </>
      ),
    },
    {
      path: Paths.test,
      element: (
        <>
          <RequireAuth>
            <DefaultLayout>
              <TestPage />
            </DefaultLayout>
          </RequireAuth>
        </>
      ),
    }, 
    {
      path: Paths.testPass, 
      element: (
        <>
          <RequireAuth>

              <DefaultLayout>
              <TestPassPage />
            </DefaultLayout>
        
          </RequireAuth>
        </>
      ),
    },
    { 
      path: Paths.admin,
      element: (
        <>
          <RequireAdmin>
            <DefaultLayout>
              <ControlPage />
            </DefaultLayout>
          </RequireAdmin>
        </>
      ),
    },
    {
      path: Paths.adminSettings,
      element: (
        <>
          <RequireSuperAdmin>
            <DefaultLayout>
              <SettingPage />
            </DefaultLayout>
          </RequireSuperAdmin>
        </>
      ),
    },
    {
      path: Paths.adminPharmacies,
      element: (
        <>
          <RequireAdmin>
            <DefaultLayout>
              <PharmaciesPage />
            </DefaultLayout>
          </RequireAdmin>
        </>
      ),
    },
    {
      path: Paths.adminPharmaciesAdd,
      element: (
        <>
          <RequireAdmin>
            <DefaultLayout>
              <PharamcyAddPage />
            </DefaultLayout>
          </RequireAdmin>
        </>
      ),
    },
    {
      path: Paths.adminPharmaciesById,
      element: (
        <>
          <RequireAdmin>
            <DefaultLayout>
              <PharamcyPage />
            </DefaultLayout>
          </RequireAdmin>
        </>
      ),
    },
    {
      path: Paths.admintestPermit ,
      element: (
        <>
          <RequireAdmin>
            <DefaultLayout>
              <TestPemitPage />
            </DefaultLayout>
          </RequireAdmin>
        </>
      ),
    },
    {
      path: Paths.adminResults,
      element: (
        <>
          <RequireAdmin>
            <DefaultLayout>
              <ResultsPage />
            </DefaultLayout>
          </RequireAdmin>
        </>
      ),
    },
    {
      path: Paths.adminResultsById,
      element: (
        <>
          <RequireAdmin>
            <DefaultLayout>
              <ResultPage />
            </DefaultLayout>
          </RequireAdmin>
        </>
      ),
    },
    {
      path: Paths.adminResultsRetake,
      element: (
        <>
          <RequireAdmin>
            <DefaultLayout>
              <RetakeResult />
            </DefaultLayout>
          </RequireAdmin>
        </>
      ),
    },
    {
      path: Paths.adminRetakeTestById,
      element: (
        <>
          <RequireAdmin>
            <DefaultLayout>
              <RetakeTest/>
            </DefaultLayout>
          </RequireAdmin>
        </>
      ),
    },
    {
      path: Paths.adminUsers,
      element: (
        <>
          <RequireAdmin>
            <DefaultLayout>
              <UsersPage/>
            </DefaultLayout>
          </RequireAdmin>
        </>
      ),
    },
    {
      path: Paths.adminUsersByUserIdEdit,
      element: (
        <>
          <RequireAdmin>
            <DefaultLayout>
              <UserEditPage/>
            </DefaultLayout>
          </RequireAdmin>
        </>
      ),
    },
    {
      path:Paths.adminUsersById,
      element: (
        <>
          <RequireAdmin>
            <DefaultLayout>
              <User/>
            </DefaultLayout>
          </RequireAdmin>
        </>
      ),
    },
    {
      path: Paths.adminUsersByIdCategoryIdTestId,
      element: (
        <>
          <RequireAdmin>
            <DefaultLayout>
              <UserResultPage/>
            </DefaultLayout>
          </RequireAdmin>
        </>
      ),
    },
    {
      path: Paths.adminMas,
      element: (
        <>
          <RequireAdmin>
            <DefaultLayout>
              <MasPage/>
            </DefaultLayout>
          </RequireAdmin>
        </>
      ),
    },
    
    {
      path: Paths.adminMasAdd,
      element: (
        <>
          <RequireAdmin>
            <DefaultLayout>
              <AddMasPage/>
            </DefaultLayout>
          </RequireAdmin>
        </>
      ),
    },
    {
      path: Paths.adminMasByUserId ,
      element: (
        <>
          <RequireAdmin>
            <DefaultLayout>
              <MasUserPage/>
            </DefaultLayout>
          </RequireAdmin>
        </>
      ),
    },
    {
      path: Paths.adminMasMasIdPhAdd,
      element: (
        <>
          <RequireAdmin>
            <DefaultLayout>
              <MasAddPharmacy/>
            </DefaultLayout>
          </RequireAdmin>
        </>
      ),
    },
    {
      path: Paths.adminTestsCategory,
      element: (
        <>
          <RequireAdmin>
            <DefaultLayout>
              <TestsCategoryPage/>
            </DefaultLayout>
          </RequireAdmin>
        </>
      ),
    },
    {
      path: Paths.adminAddTest,
      element: (
        <>
          <RequireAdmin>
            <DefaultLayout>
              <AddTestQuestionPage/>
            </DefaultLayout>
          </RequireAdmin>
        </>
      ),
    },

    {
      path: Paths.adminCheckTests,
      element: (
        <>
          <RequireAdmin>
            <DefaultLayout>
              <CheckTestsPage/>
            </DefaultLayout>
          </RequireAdmin>
        </>
      ),
    },

    {
      path: Paths.adminEditTestTestId,
      element: (
        <>
          <RequireAdmin>
            <DefaultLayout>
              <EditTestPage/>
            </DefaultLayout>
          </RequireAdmin>
        </>
      ),
    },
    
    
    {
      path: Paths.adminAddTestCategory,
      element: (
        <>
          <RequireAdmin>
            <DefaultLayout>
              < AddTestCategoryPage/>
            </DefaultLayout>
          </RequireAdmin>
        </>
      ),
    },

    {
      path: Paths.adminReports,
      element: (
        <>
          <RequireAdmin>
            <DefaultLayout>
              < ReportsPage/>
            </DefaultLayout>
          </RequireAdmin>
        </>
      ),
    },
    {
      path: Paths.adminMasRegionPharmacy,
      element: (
        <>
          <RequireAdmin>
            <DefaultLayout>
              < ReportMasRegionPharmacyPage/>
            </DefaultLayout>
          </RequireAdmin>
        </>
      ),
    },

    {
      path: Paths.adminMasRegionPharmacyById,
      element: (
        <>
          <RequireAdmin>
            <DefaultLayout>
              < ReportMasRegionPharmacyCategoryIdPage/>
            </DefaultLayout>
          </RequireAdmin>
        </>
      ),
    },

    {
      path: "*",
      element: (
        <>
         
            <DefaultLayout>
              <h1 style={{textAlign: 'center', color: 'crimson', marginTop: 20}}> Страница не найдена </h1>
            </DefaultLayout>
          
        </>
      ),
    },

    
   
    
  ]);